import { useState, useEffect } from "react";
import { X, Download, Smartphone } from "lucide-react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=date.perfecthorse.havenpositive";
const DISMISSED_KEY = "gp_banner_dismissed";

export default function GooglePlayBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISSED_KEY)) return;

    const ua = (navigator.userAgent || "").toLowerCase();
    const isAndroid = /android/i.test(ua);
    const isInApp = /wv|webview/i.test(ua);

    if (isAndroid && !isInApp) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, "true");
    } catch {
    }
    setVisible(false);
  };

  const handleInstall = () => {
    window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
    handleDismiss();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-green-500 shadow-lg p-3 sm:p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-3">
        <button
          onClick={handleDismiss}
          className="p-1 rounded-full hover:bg-gray-100 flex-shrink-0"
          aria-label="Close"
        >
          <X className="w-5 h-5 text-gray-400" />
        </button>

        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="bg-green-500 text-white p-2 rounded-xl flex-shrink-0">
            <Smartphone className="w-6 h-6" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-900 truncate">
              Haven – Dating App
            </p>
            <p className="text-xs text-gray-500">
              Get the app for a better experience!
            </p>
          </div>
        </div>

        <button
          onClick={handleInstall}
          className="flex items-center gap-1.5 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-green-600 transition-colors whitespace-nowrap flex-shrink-0"
        >
          <Download className="w-4 h-4" />
          Install
        </button>
      </div>
    </div>
  );
}